import React, { Component } from 'react';
import autoBind from "react-autobind";
import queryString from "query-string";
import saIdParser from "south-african-id-parser";
import { isEmpty } from 'ramda';
import serializeError from 'serialize-error';

import history from '../../history';
import logger from '../../common/logger';
import updateState from '../../common/updateState';
import { StartQuestionnaire } from './StartQuestionnaire';
import validate from '../../common/formValidation/validate';
import commonSchemas from '../../common/formValidation/common.schema';
import validateForm from '../../common/formValidation/validateForm';
import api, { setToken } from '../../common/api';

export class StartQuestionnaireContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this);

    this.initializeState(props.location);
  }

  initializeState(location) {
    const params = queryString.parse(location.search);

    if (!params.questionnaireName) {
      logger.error(new Error('questionnaireName was missing in parameters to start a questionnnaire'));
      history.push({
        pathname: '/error',
        state: {
          error: "Cannot start questionnaire without name"
        }
      })
    }

    if (!params.questionnaireVersion) {
      logger.error(new Error('questionnaireVersion was missing in parameters to start a questionnnaire'));
      history.push({
        pathname: '/error',
        state: {
          error: "Cannot start questionnaire without version"
        }
      })
    }

    if (!params.token) {
      logger.error(new Error('token was missing in parameters to start a questionnnaire'));
      history.push({
        pathname: '/error',
        state: {
          error: "Cannot start questionnaire without token"
        }
      })
    }

    setToken(params.token)

    let rsaId = {
      value: "",
      touched: false,
      isValid: false,
      errorMessage: "",
      canBeChanged: true
    }

    if (params.rsaId) {
      const errorMessage = this.getRsaIdErrorMessage(params.rsaId)
      rsaId.value = params.rsaId;
      rsaId.touched = true;
      rsaId.isValid = isEmpty(errorMessage);
      rsaId.errorMessage = errorMessage;
      rsaId.canBeChanged = false // ID number may not be changed if it's included in the redirect
    }

    this.state = {
      busy: false,
      startQuestionnaireForm: {
        rsaId
      },
      questionnaire: {
        name: params.questionnaireName,
        version: params.questionnaireVersion
      }
    }
  }

  start() {
    updateState(this, { busy: true })

    api().
      post('questionnaire', {
        rsaId: this.state.startQuestionnaireForm.rsaId.value,
        questionnaireName: this.state.questionnaire.name,
        questionnaireVersion: this.state.questionnaire.version
      }).
      then((response) => {
        history.push({ pathname: '/questionnaire', search: `?sessionId=${response.data.sessionId}` })
      }).
      catch((error) => {
        logger.error(error);
        history.push({
          pathname: '/error',
          search: `?sessionId=${this.state.sessionId}`,
          state: {
            error: serializeError(error)
          }
        })
      })
  }

  getRsaIdErrorMessage(rsaId) {
    let errorMessage = validate(rsaId, commonSchemas.rsaId);

    if (!errorMessage) {
      const info = saIdParser.parse(rsaId);
      if (!info.isValid) {
        errorMessage = "Please enter a valid South African ID number. The ID number entered is invalid"
      }
    }
    return errorMessage;
  }

  onRsaIdChange(event) {
    const newRsaIdValue = event.target.value
    const errorMessage = this.getRsaIdErrorMessage(newRsaIdValue)

    updateState(this, {
      startQuestionnaireForm: {
        rsaId: {
          touched: true,
          value: newRsaIdValue,
          isValid: isEmpty(errorMessage),
          errorMessage: errorMessage
        }
      }
    });
  }

  render() {
    const { busy, startQuestionnaireForm } = this.state
    return <StartQuestionnaire
      formIsValid={validateForm(startQuestionnaireForm)}
      busy={busy}
      rsaId={startQuestionnaireForm.rsaId}
      onRsaIdChange={this.onRsaIdChange}
      start={this.start}
      questionnaireName={this.state.questionnaire.name}
    />
  }
}




// WEBPACK FOOTER //
// ./src/components/startQuestionnaire/StartQuestionnaireContainer.js